import React, { useEffect, useState } from "react"
import { get } from "helpers/api_helper";


const UserAdministration = props => {

  useEffect(async () => {
    // let params={
    //   vendor_id:1,
    //   api_token: 'mf1vVLCfpknczCdGAauKutvrsyKaBU'
    // }
    // const resp = await get("/features-available");
    // console.log(resp);
    // setTimeout(() => {
    //   setSubscribemodal(true)
    // }, 2000);
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        User Administration Page
      </div>
    </React.Fragment>
  )
}

export default UserAdministration
